/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_4_DescInputs */

const en_mk_problem_4_desc = /** @type {(inputs: Mk_Problem_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every new chat starts from zero. It doesn't know your product, your prices, your customers, or the words your team never uses.`)
};

const id_mk_problem_4_desc = /** @type {(inputs: Mk_Problem_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap obrolan baru mulai dari nol. Tidak kenal produk, harga, pelanggan, atau kata yang dilarang dipakai timmu.`)
};

/**
* | output |
* | --- |
* | "Every new chat starts from zero. It doesn't know your product, your prices, your customers, or the words your team never uses." |
*
* @param {Mk_Problem_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_4_desc = /** @type {((inputs?: Mk_Problem_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_4_desc(inputs)
	return en_mk_problem_4_desc(inputs)
});